import { useState } from "react";
import { Navbar } from "./Navbar";
import Sidebar from "./Sidebar";

const SIDEBAR_WIDTH = "w-64";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="flex flex-col w-full h-screen overflow-hidden">
      <Navbar toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />

      <div className="flex-1 flex h-full overflow-hidden">
        <aside
          className={`${SIDEBAR_WIDTH} shrink-0 hidden md:block bg-gradient-to-b from-[#3900b0] to-[#5b00ff] text-white`}
        >
          <Sidebar />
        </aside>

        <aside
          className={`
            ${SIDEBAR_WIDTH}
            bg-gradient-to-b from-[#3900b0] to-[#5b00ff] text-white
            fixed inset-y-0 left-0 z-50 md:hidden
            transform transition-transform duration-300
            ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
          `}
        >
          <button
            onClick={() => setIsSidebarOpen(false)}
            className="md:hidden absolute top-2 right-2 text-2xl leading-none"
            aria-label="Close menu"
          >
            ×
          </button>
          <Sidebar onNavigate={() => setIsSidebarOpen(false)} />
        </aside>

        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black/40 z-40 md:hidden"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
        <main className="flex-1 overflow-auto bg-white px-4 pt-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
